import { useEffect, useState } from 'react'

import { useSessionContext } from 'hooks/SessionContext'

import { CustomerBase } from 'types/Customer'

import Api from 'services/api'

const useCustomersPiiInfo = () => {
  const { session: { dealerId } } = useSessionContext()
  const [customers, setCustomers] = useState<Array<CustomerBase> | null>(null)
  const [areCustomersLoaded, setAreCustomersLoaded] = useState(false)

  useEffect(() => {
    if (!dealerId) {
      setAreCustomersLoaded(true)

      return
    }

    Api.Customers.getPiiInfo(dealerId)
      .then((res : Array<CustomerBase> | null) => {
        setCustomers(res)
      })
      .catch(() => {
        setCustomers(null)
      })
      .finally(() => {
        setAreCustomersLoaded(true)
      })
  }, [dealerId])

  return { customers, areCustomersLoaded }
}

export default useCustomersPiiInfo
